import { z, isoZ } from 'my-zod'

export const outfitterGroupAssignmentsModel = z.object({
  id: z.number(),
  shortId: z.string(),
  outfitterGroupId: z.number(),
  outfitterId: z.number(),
  vehicleId: z.number(),
  createdDate: isoZ.instant(),
  completionDate: isoZ.instant().nullable(),
  firstMileage: z.number().nullable(),
  firstEngineHours: z.number().nullable(),
  firstTreadDepth: z.number().nullable(),
  lastMileage: z.number().nullable(),
  lastEngineHours: z.number().nullable(),
  lastTreadDepth: z.number().nullable(),
  lastModifiedDate: isoZ.instant()
})

export type outfitterGroupAssignmentsModel = z.infer<typeof outfitterGroupAssignmentsModel>
